import { Livewire, Alpine } from '../../../../../../../../vendor/livewire/livewire/dist/livewire.esm';
import Clipboard from '@ryangjchandler/alpine-clipboard'

Alpine.plugin(Clipboard)
Livewire.start()

// Swiper
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
window.Swiper = Swiper

// import * as Sentry from "@sentry/browser";
//
// Sentry.init({
//     dsn: import.meta.env.VITE_SENTRY_DSN_PUBLIC,
//     integrations: [
//         Sentry.browserTracingIntegration(),
//         Sentry.replayIntegration(),
//     ],
//     // Performance Monitoring
//     tracesSampleRate: 1.0, //  Capture 100% of the transactions
//     // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
//     // tracePropagationTargets: ["qorfechi.com"],
//     // Session Replay
//     replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
//     replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
// });

// import MultiSelect from './multiSelect'
// import accordionSelectedType from './accordion'

// Turbo links
// import * as Turbo from "@hotwired/turbo"
// var Turbolinks = require("turbolinks");
// Turbolinks.start();

// Alpine
// import Alpine from 'alpinejs'
// import FormsAlpinePlugin from '../../../../../../../vendor/filament/forms/dist/module.esm'
//
// Alpine.plugin(FormsAlpinePlugin);
// window.Alpine = Alpine
// Alpine.start()

// Swal
import Swal from 'sweetalert2';
window.Swal = Swal;
window.Toast = Swal.mixin({
    toast: true,
    position: 'top-right',
    iconColor: 'white',
    customClass: {
        popup: 'colored-toast'
    },
    showConfirmButton: false,
    timer: 3330,
    timerProgressBar: true
});

// Lazyload
import lazySizes from 'lazysizes';

// Plyr
import Plyr from 'plyr';
import 'plyr/src/sass/plyr.scss'


// Tippy JS
import tippy from 'tippy.js';
import 'tippy.js/animations/shift-away.css';
import 'tippy.js/themes/light.css';
import 'tippy.js/dist/tippy.css';
const setupApp = ()=>
{
    lazySizes.init();

    tippy('.tippyBtn',{
        content(reference) {
            const id = reference.getAttribute('data-template');
            const template = document.getElementById(id);
            if( template )
                return template.innerHTML;
            return null;
        },
        theme: 'light',
        animation: 'shift-away',
        interactive: true,
        allowHTML: true,
        duration: 300,
        maxWidth: 250,
        delay: [300, 400],
    });

    const myVideoPlayer = new Plyr('#myVideoPlayer', {
        ratio: '16:9',
    });

    const myAudioPlayer = new Plyr('#myAudioPlayer');

    const featuresSwiper = new Swiper('.features-swiper', {
        direction: 'horizontal',
        slidesPerView: 1.1,
        spaceBetween:20,
        clickable: "true",
        centeredSlides: true,
        centeredSlidesBounds: true,
        breakpoints: {
            640:{
                slidesPerView: 1.8,
            },
            768:{
                slidesPerView: 2.2,
            },
            1024: {
                slidesPerView: 2.4,
            },
            1280:{
                slidesPerView: 3,
            },
            1536:{
                slidesPerView:3.1,
                centeredSlides:true,
                centeredSlidesBounds:true,
                enabled:false,
            }
        }

    })
    const servicesSwiper = new Swiper('.services-swiper', {
        direction: 'horizontal',
        slidesPerView: 1.3,
        spaceBetween:30,
        clickable: "true",
        centeredSlides: true,
        centeredSlidesBounds: true,
        breakpoints: {
            768:{
                slidesPerView: 2.2,
            },
            640:{
                slidesPerView: 2.1,
            },
            1024: {
                slidesPerView: 3.1,
            },
            1280:{
                slidesOffsetBefore:10,
                slidesOffsetAfter:10,
                slidesPerView: 4.1,
                enabled: false,
            },
        }

    })
    const blogSwiper = new Swiper('.blog-swiper', {
        // direction: 'horizontal',
        slidesPerView: 1.2,
        spaceBetween: 10,
        // clickable: "true",
        // centeredSlides: true,
        // centeredSlidesBounds: true,
        breakpoints: {
            640:{
                slidesPerView: 1.3,
            },
            768:{
                slidesPerView: 2.3,
            },
            1024: {
                slidesPerView: 3.3,
            },
            1280:{
                // slidesOffsetBefore:10,
                // slidesOffsetAfter:10,
                slidesPerView: 5.3,
            },
            1920: {
                slidesPerView: 5.3,
            },
        }
    })

    const latestWorksSwiper = new Swiper('.latest-works-swiper', {
        direction: 'horizontal',
        slidesPerView: 'auto',
        centeredSlides: true,
        centeredSlidesBounds: true,
        loop: true,
        autoplay: true,
        // spaceBetween:30,
        clickable: "true",
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            nextEl: '.latest-works-navigation-next',
            prevEl: '.latest-works-navigation-prev',
            disabledClass: 'text-gray-400 bg-gray-500 transform scale-90',
        },

        // breakpoints: {
        //   768:{
        //     slidesPerView: 2.2,
        //   },
        //   1024: {
        //     slidesPerView: 2.8,
        //   },
        //   1280:{
        //     slidesPerView: 4,
        //   },
        // }

    })
    const latestWorksDesktopIphoneSwiper = new Swiper('.latest-works-desktop-swiper', {
        direction: 'horizontal',
        slidesPerView: 1,
        centeredSlidesBounds: true,
        centeredSlides: true,
        loop: true,
        autoplay: true,
        allowTouchMove: false,
        clickable: "true",
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            nextEl: '.latest-works-navigation-next',
            prevEl: '.latest-works-navigation-prev',
            disabledClass: 'text-gray-400 bg-gray-500 transform scale-90',
        },

        // breakpoints: {
        //   768:{
        //     slidesPerView: 2.2,
        //   },
        //   1024: {
        //     slidesPerView: 2.8,
        //   },
        //   1280:{
        //     slidesPerView: 4,
        //   },
        // }

    })

    const testimonialsSwiper = new Swiper('.testimonial-swiper', {
        direction: 'horizontal',
        slidesPerView: 1,
        spaceBetween:30,


        // effect: 'coverflow',
        // coverflowEffect: {
        //   rotate: 60,
        //   slideShadows: false,
        // },
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            bulletClass:'swiper-pagination-bullet',
            clickable:true,
        },
        breakpoints: {

            //   1024: {
            //     slidesPerView: 2.8,
            //   },
            1536:{
                slidesPerView: 1.4,
            },
        }

    })

    const worksOnProgressSwiper = new Swiper('.works-on-progress-swiper', {
        direction: 'vertical',
        slidesPerView: 1.2,
        // initialSlide:1,
        slideActiveClass:'swiper-slide-active relative z-20 backdrop-blur-2xl',
        // slidePrevClass:'swiper-slide-prev scale-90 transform translate-y-52 -translate-z-10 filter blur-sm transition duration-300 ease-in',
        // slideNextClass:'swiper-slide-next scale-90 transform -translate-y-52 -translate-z-10 filter blur-sm transition duration-300 ease-in',
        centeredSlidesBounds:true,
        centeredSlides: true,
        autoplay: true,
        loop: true,
        // spaceBetween: 20,
        clickable: true,
        effect: 'cards',
        // creativeEffect: {
        //   prev: {
        //     // will set `translateZ(-400px)` on previous slides
        //     scale:0.9,
        //     translate: [0, 0, -400],

        //   },
        //   next: {
        //     // will set `translateX(100%)` on next slides
        //     scale:0.9,
        //     translate: [0, 0, -400],
        //   },
        // },
        navigation: {
            nextEl: '.works-on-progress-navigation-next',
            prevEl: '.works-on-progress-navigation-prev',
            disabledClass: 'before:text-gray-200 after:text-gray-200 bg-gray-500 transform scale-90',
        },
        // breakpoints: {
        //   768:{
        //     slidesPerView: 2.2,
        //   },
        //   1024: {
        //     slidesPerView: 2.8,
        //   },
        //   1280:{
        //     slidesPerView: 4,
        //   },
        // }

    });

    const websiteServiceStepsSwiper = new Swiper('.website-service-steps-swiper', {
        direction: 'horizontal',
        slidesPerView: 1,
        centeredSlidesBounds: true,
        centeredSlides: true,
        clickable: "true",
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            nextEl: '.website-service-steps-navigation-next',
            prevEl: '.website-service-steps-navigation-prev',
            disabledClass: 'text-gray-400 bg-gray-500 transform scale-90',
        },

        breakpoints: {
            768:{
                pagination: {
                    el: '.website-service-steps-progressbar',
                    type: 'progressbar',
                    progressbarFillClass: 'swiper-pagination-progressbar-fill !bg-primary-700 !rounded-lg',
                }
            },
            // 1024: {
            //   slidesPerView: 2.8,
            // },
            // 1280:{
            //   slidesPerView: 4,
            // },
        }

    })
    const websiteServicePlatformsOpt = {
        el: '.website-service-platforms-swiper',
        direction: 'horizontal',
        slidesPerView: 1.15,
        spaceBetween:20,
        // clickable: "true",
        centeredSlides: true,
        centeredSlidesBounds: true,
        breakpoints: {
            768:{
                slidesPerView: 2.2,
            },
            640:{
                slidesPerView: 2.1,
            },
            1024: {
                slidesPerView: 3.1,
            },
            1280:{
                slidesOffsetBefore:10,
                slidesOffsetAfter:10,
                slidesPerView: 4.1,
                enabled: false,
            },
        }

    }
    let websiteServicePlatforms = new Swiper('.website-service-platforms-swiper', websiteServicePlatformsOpt)
    const websiteServiceFeaturesSwiperOpt =  {
        el: '.website-service-features-swiper',
        direction: 'horizontal',
        slidesPerView: 1.3,
        spaceBetween:20,
        loop:true,
        // clickable: "true",
        centeredSlides: true,
        centeredSlidesBounds: true,
        breakpoints: {
            768:{
                slidesPerView: 3.2,
            },
            640:{
                slidesPerView: 2.1,
            },
            1024:{
                slidesOffsetBefore:10,
                slidesOffsetAfter:10,
                slidesPerView: 4,
                enabled: false,
            },
        }

    }
    let websiteServiceFeatures = new Swiper('.website-service-features-swiper', websiteServiceFeaturesSwiperOpt)
    const websiteServiceDeliverables = new Swiper('.website-service-deliverables-swiper', {
        direction: 'horizontal',
        slidesPerView: 1.1,
        spaceBetween:30,
        // clickable: "true",
        centeredSlides: true,
        centeredSlidesBounds: true,
        breakpoints: {
            768:{
                slidesPerView: 2.2,
            },
            640:{
                slidesPerView: 2.1,
            },
            1024: {
                slidesPerView: 3.1,
            },
            1280:{
                slidesOffsetBefore:10,
                slidesOffsetAfter:10,
                slidesPerView: 4.1,
                enabled: false,
            },
        }

    })

// Platform Pages ///

    const platformsAudienceSwiperOpt =  {
        el: '.platforms-audience-swiper',
        direction: 'horizontal',
        slidesPerView: 1.7,
        spaceBetween:20,
        loop:true,
        // clickable: "true",
        centeredSlides: true,
        centeredSlidesBounds: true,
        breakpoints: {
            768:{
                slidesPerView: 3.7,
            },
            640:{
                slidesPerView: 2.1,
            },
            1024:{
                slidesOffsetBefore:10,
                slidesOffsetAfter:10,
                slidesPerView: 4,
                enabled: false,
            },
        }
    }
    let platformsAudienceSwiper = new Swiper('.platforms-audience-swiper', platformsAudienceSwiperOpt )

    const platformsKeyFeaturesSwiperOpt =  {
        el: '.platforms-key-features-swiper',
        direction: 'horizontal',
        slidesPerView: 1.1,
        spaceBetween:20,
        // loop:true,
        // clickable: "true",
        // centeredSlides: true,
        // centeredSlidesBounds: true,
        breakpoints: {
            768:{
                slidesPerView: 1.7,
            },
            640:{
                slidesPerView: 2.1,
            },
            1024:{
                slidesOffsetBefore:10,
                slidesOffsetAfter:10,
                slidesPerView: 4,
                enabled: false,
            },
        }

    }
    let platformsKeyFeaturesSwiper = new Swiper('.platforms-key-features-swiper', platformsKeyFeaturesSwiperOpt )


    const startupPlatformsKeyFeaturesSwiperOpt =  {
        el: '.startup-platforms-key-features-swiper',
        direction: 'horizontal',
        slidesPerView: 1.1,
        spaceBetween:20,
        // loop:true,
        // clickable: "true",
        // centeredSlides: true,
        // centeredSlidesBounds: true,
        breakpoints: {
            768:{
                slidesPerView: 1.7,
            },
            640:{
                slidesPerView: 2.1,
            },
            1024:{
                slidesOffsetBefore:10,
                slidesOffsetAfter:10,
                slidesPerView: 4,
                enabled: false,
            },
        }

    }
    let startupPlatformsKeyFeaturesSwiper = new Swiper('.startup-platforms-key-features-swiper', startupPlatformsKeyFeaturesSwiperOpt )

// Features Page

    const featuresScreenshotsSwiper = new Swiper('.feature-screenshots-swiper-cont', {
        slidesPerView: 1,
        spaceBetween:30,
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            bulletClass:'swiper-pagination-bullet',
            clickable:true,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
            disabledClass: 'after:text-gray-400 transform scale-90',
        },


    })
    const serviceTitlesSwiper = new Swiper('.service-titles-swiper-cont', {
        slidesPerView: 1,
        spaceBetween:60,
        centeredSlides:true,
        centeredSlidesBounds:true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
            disabledClass: 'after:text-gray-400 transform scale-75 transition-all',
        },

        breakpoints: {
            370: {
                slidesPerView: 1.15,
            },
            430: {
                slidesPerView:1.3,
            },
            500: {
                slidesPerView: 1.5,
            },
            530: {
                slidesPerView: 1.8,
            },
            640:{
                slidesPerView: 2.1,
            },
            768:{
                slidesPerView: 2.5,
            },
            1024: {
                slidesPerView: 3.3,
            },
            1280:{
                slidesPerView: 4,
            },
            1536:{
                slidesPerView:4.5,
                centeredSlides:true,
                centeredSlidesBounds:true,
                // clickable:false,
                // enabled:false,
            }
        }


    })
    const contentServiceTitlesSwiper = new Swiper('.content-service-titles-swiper-cont', {
        slidesPerView: 1,
        spaceBetween:60,
        centeredSlides:true,
        centeredSlidesBounds:true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
            disabledClass: 'after:text-gray-400 transform scale-75 transition-all',
        },

        breakpoints: {
            370: {
                slidesPerView: 1.3,
            },
            430: {
                slidesPerView:1.6,
            },
            500: {
                slidesPerView: 1.7,
            },
            530: {
                slidesPerView: 2,
            },
            640:{
                slidesPerView: 2.3,
            },
            768:{
                slidesPerView: 3.2,
            },
            1024: {
                slidesPerView: 3.6,
            },
            1280:{
                slidesPerView: 4.7,
            },
            1536:{
                slidesPerView:4.2,
                centeredSlides:true,
                centeredSlidesBounds:true,
                // clickable:false,
                // enabled:false,
            }
        }


    })

    const seoServiceTitlesSwiper = new Swiper('.seo-service-titles-swiper-cont', {
        slidesPerView: 1,
        spaceBetween:60,
        centeredSlides:true,
        centeredSlidesBounds:true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
            disabledClass: 'after:text-gray-400 transform scale-75 transition-all',
        },

        breakpoints: {
            370: {
                slidesPerView: 1.3,
            },
            430: {
                slidesPerView:1.6,
            },
            500: {
                slidesPerView: 1.7,
            },
            530: {
                slidesPerView: 2.2,
            },
            640:{
                slidesPerView: 2.7,
            },
            768:{
                slidesPerView: 3.6,
            },
            1024: {
                slidesPerView: 3.9,
            },
            1280:{
                slidesPerView: 4.2,
            },
            1536:{
                slidesPerView:4.2,
                // centeredSlides:true,
                // centeredSlidesBounds:true,
                // clickable:false,
                // enabled:false,
            }
        }


    })

    const operationServiceTitlesSwiper = new Swiper('.operation-service-titles-swiper-cont', {
        slidesPerView: 1,
        spaceBetween:60,
        centeredSlides:true,
        centeredSlidesBounds:true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
            disabledClass: 'after:text-gray-400 transform scale-75 transition-all',
        },

        breakpoints: {
            370: {
                slidesPerView: 1.15,
            },
            430: {
                slidesPerView:1.3,
            },
            500: {
                slidesPerView: 1.5,
            },
            530: {
                slidesPerView: 1.8,
            },
            640:{
                slidesPerView: 2.1,
            },
            768:{
                slidesPerView: 2.5,
            },
            1024: {
                slidesPerView: 3,
            },
            1280:{
                slidesPerView: 3,
            },
            1536:{
                slidesPerView:3,
                centeredSlides:true,
                centeredSlidesBounds:true,
                // clickable:false,
                // enabled:false,
            }
        }
    })

    const blogHeroSwiper = new Swiper('#blogHeroSwiper', {
        slidesPerView: 1,
        autoplay: true,
        pagination: {
            el: ".swiper-pagination",
        },
    })

    let blogCategoriesSwiperOpt = {
        slidesPerView: 1.7,
        spaceBetween:20,
        loop:true,
        centeredSlides: true,
        centeredSlidesBounds: true,
        breakpoints: {
            768:{
                slidesPerView: 3.7,
            },
            640:{
                slidesPerView: 2.1,
            },
            1024:{
                enabled: false,
                centeredSlides: false,
                centeredSlidesBounds: false,
                slidesPerView: 5,
                spaceBetween: 5,
                // grid: {
                //     rows: 2,
                //     fill: 'row'
                // },
            },
        }

    };

    let blogCategoriesSwiper = new Swiper('#blogCategoriesSwiper', blogCategoriesSwiperOpt)

    let portfolioCategoriesSwiperOpt = {
        slidesPerView: 1.7,
        spaceBetween:20,
        loop:true,
        centeredSlides: true,
        centeredSlidesBounds: true,
        breakpoints: {
            768:{
                slidesPerView: 3.7,
            },
            640:{
                slidesPerView: 2.1,
            },
            1024:{
                enabled: false,
                centeredSlides: false,
                centeredSlidesBounds: false,
                slidesPerView: 5,
                spaceBetween: 5,
                // grid: {
                //     rows: 2,
                //     fill: 'row'
                // },
            },
        }

    };

    let portfolioCategoriesSwiper = new Swiper('#portfolioCategoriesSwiper', portfolioCategoriesSwiperOpt)


    const specialCaegorySwiper = new Swiper('#specialCaegorySwiper', {
        slidesPerView: 1.3,
        spaceBetween: 10,
        breakpoints: {
            640:{
                slidesPerView: 1.3,
            },
            768:{
                slidesPerView: 2.3,
            },
            1024: {
                slidesPerView: 3.3,
            },
            1280:{
                slidesPerView: 4.3,
            },
            1920: {
                slidesPerView: 4.5,
            },
        }
    })

    const portfolioSwiper = new Swiper("#portfolioSwiper", {
        slidesPerView: 1.3,
        spaceBetween: 20,
        breakpoints: {
            640:{
                slidesPerView: 1.3,
            },
            768:{
                slidesPerView: 2.3,
            },
            1024: {
                slidesPerView: 2.5,
            },
            1280:{
                slidesPerView: 3,
            },
            1920: {
                slidesPerView: 3,
            },
        },
        navigation: {
            nextEl: "#portfolioSwiperPrev",
            prevEl: "#portfolioSwiperNext",
        },
    });

    const breakpoint = window.matchMedia( '(min-width:1024px)' );
    if ( breakpoint.matches === true  ) {
        // console.log(websiteServiceFeatures, websiteServicePlatforms, platformsAudienceSwiper,  platformsKeyFeaturesSwiper.el instanceof HTMLElement)
        // console.log('matched')
        try {
            if( websiteServiceFeatures.el instanceof HTMLElement) {
                websiteServiceFeatures.destroy()
                document.getElementById("website-page-features-swiper-wrapper").classList.remove("swiper-wrapper");
                // console.log('websiteServiceFeatures destroy')
            }
            if( websiteServicePlatforms.el instanceof HTMLElement) {
                websiteServicePlatforms.destroy()
                document.getElementById("website-service-platforms-swiper-wrapper").classList.remove("swiper-wrapper");
            }
            if( platformsAudienceSwiper.el instanceof HTMLElement) {
                platformsAudienceSwiper.destroy()
                document.getElementById("platforms-audience-swiper-wrapper").classList.remove("swiper-wrapper");
            }
            if( platformsKeyFeaturesSwiper.el instanceof HTMLElement) {
                platformsKeyFeaturesSwiper.destroy()
                document.getElementById("platforms-key-features-swiper-wrapper").classList.remove("swiper-wrapper");
            }
            if( startupPlatformsKeyFeaturesSwiper.el instanceof HTMLElement) {
                startupPlatformsKeyFeaturesSwiper.destroy()
                document.getElementById("startup-platforms-key-features-swiper-wrapper").classList.remove("swiper-wrapper");
            }
            if( blogCategoriesSwiper.el instanceof HTMLElement) {
                blogCategoriesSwiper.destroy()
                document.getElementById("blogCategoriesSwiperWrapper").classList.remove("swiper-wrapper");
            }
            if( portfolioCategoriesSwiper.el instanceof HTMLElement) {
                portfolioCategoriesSwiper.destroy()
                document.getElementById("portfolioCategoriesSwiperWrapper").classList.remove("swiper-wrapper");
            }
            // console.log(websiteServiceFeatures, websiteServicePlatforms, platformsAudienceSwiper, platformsKeyFeaturesSwiper)

        } catch(e) {
            console.log(e)
        }
    }
    else if ( breakpoint.matches === false ) {
        // console.log('not matched')
        // console.log(websiteServiceFeatures.enabled , websiteServicePlatforms.enabled, platformsAudienceSwiper.enabled ,  platformsKeyFeaturesSwiper.enabled)

        if(!websiteServiceFeatures.enabled){
            document.getElementById("website-page-features-swiper-wrapper").classList.add("swiper-wrapper");
            websiteServiceFeatures = new Swiper(websiteServiceFeaturesSwiperOpt)
        }
        if(!websiteServicePlatforms.enabled){
            document.getElementById("website-service-platforms-swiper-wrapper").classList.add("swiper-wrapper");
            websiteServicePlatforms = new Swiper(websiteServicePlatformsOpt)
        }
        if( !platformsAudienceSwiper.enabled ) {
            document.getElementById("platforms-audience-swiper-wrapper").classList.add("swiper-wrapper");
            platformsAudienceSwiper = new Swiper(platformsAudienceSwiperOpt)
        }
        if( !platformsKeyFeaturesSwiper.enabled ) {
            document.getElementById("platforms-key-features-swiper-wrapper").classList.add("swiper-wrapper");
            platformsKeyFeaturesSwiper = new Swiper(platformsKeyFeaturesSwiperOpt)
        }
        if( !startupPlatformsKeyFeaturesSwiper.enabled ) {
            document.getElementById("startup-platforms-key-features-swiper-wrapper").classList.add("swiper-wrapper");
            startupPlatformsKeyFeaturesSwiper = new Swiper(startupPlatformsKeyFeaturesSwiperOpt)
        }
        if( !blogCategoriesSwiper.enabled ) {
            document.getElementById("blogCategoriesSwiperWrapper").classList.add("swiper-wrapper");
            blogCategoriesSwiper = new Swiper(blogCategoriesSwiperOpt)
        }
        if( !portfolioCategoriesSwiper.enabled ) {
            document.getElementById("portfolioCategoriesSwiperWrapper").classList.add("swiper-wrapper");
            portfolioCategoriesSwiper = new Swiper(portfolioCategoriesSwiperOpt)
        }
    }

    // myUndefinedFunction();
};

["livewire:load", "livewire:update", "livewire:initialized", "livewire:navigated", "resize", "pageChanged"].forEach((event) => {
    window.addEventListener(event, setupApp)
})
